module.exports = __webpack_public_path__ + "static/media/international-cover.749c4f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/international-cover.jpg
// module id = 259
// module chunks = 0